import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { ModalBase } from '@shared/abstraction/modal/modal-base';
import { DictionaryManagerService } from '@shared/modules/rich-editor/services/dictionary-manager.service';
import { RichEditorService } from '@shared/modules/rich-editor/services/rich-editor.service';
import { SpellcheckWorkerAdapterService } from '@shared/modules/rich-editor/services/spellcheck-worker-adapter.service';
import { SpellcheckerService } from '@shared/modules/rich-editor/services/spellchecker.service';
import { RichEdit } from 'devexpress-richedit';

@Component({
  standalone: false,
  selector: 'gstar-explanation-editor',
  templateUrl: './explanation-editor.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    RichEditorService,
    SpellcheckerService,
    SpellcheckWorkerAdapterService,
    DictionaryManagerService,
  ],
})
export class ExplanationEditorComponent implements ModalBase {
  data = input.required<{ title: string; content: string }>();

  editor = signal<RichEdit | undefined>(undefined);

  updateHandler(editor: RichEdit | undefined): void {
    this.editor.set(editor);
  }

  getData(): unknown {
    return this.editor();
  }
}
